import { create, useModal } from '@ebay/nice-modal-react';
import { t } from 'i18next';
import { ReactNode, useState } from 'react';

import ConfirmationPopup from 'modules/ConfirmationPopup/ConfirmationPopup';
import { IconType } from 'utils/types';

interface ConfirmationModalProps {
  message: ReactNode;
  confirmButtonText: string;
  icon: IconType;
  onConfirm: () => Promise<void>;
  confirmButtonVariant?: 'destructive' | 'primary';
  iconClassName?: string;
}

const ConfirmationModal = create(
  ({
    message,
    confirmButtonText,
    icon: Icon,
    onConfirm,
    confirmButtonVariant = 'destructive',
    iconClassName = 'text-tertiary-50',
  }: ConfirmationModalProps) => {
    const { remove } = useModal(ConfirmationModal);
    const [isLoading, setIsLoading] = useState(false);

    const handleConfirm = () => {
      setIsLoading(true);
      onConfirm().finally(() => {
        setIsLoading(false);
        remove();
      });
    };

    return (
      <ConfirmationPopup onClose={remove} isVisible>
        <ConfirmationPopup.Content icon={Icon} iconClassName={iconClassName}>
          {message}
        </ConfirmationPopup.Content>
        <ConfirmationPopup.Footer>
          <ConfirmationPopup.Button variant="secondaryTertiary" onClick={remove}>
            {t('cancel')}
          </ConfirmationPopup.Button>
          <ConfirmationPopup.Button variant={confirmButtonVariant} onClick={handleConfirm} loading={isLoading}>
            {confirmButtonText}
          </ConfirmationPopup.Button>
        </ConfirmationPopup.Footer>
      </ConfirmationPopup>
    );
  }
);

export default ConfirmationModal;
